import SemrSkeleton from '@semcore/ui/skeleton';
export { LineChartSkeleton } from '@semcore/ui/skeleton';
export const Skeleton = SemrSkeleton;
